module.exports = __webpack_public_path__ + "img/germany-diabetes-mellitus-female.5fe9e470.png";